module.exports = __webpack_public_path__ + "img/MES10VideoThumbnail.937c9a11.png";